import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import type { FieldSummaryData } from "../../Types/VoiceAssistant/VoiceAssistantTypes";
import FieldSummaryPanel from "./FieldSummaryPanel";

type Props = {
  open: boolean;
  data: FieldSummaryData | null;
  onClose: () => void;
};

export default function FieldSummaryModal({ open, data, onClose }: Props) {
  if (!data) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", pr: 1 }}>
        <Typography variant="h6" fontWeight={700} flex={1}>
          Patient details
        </Typography>
        <IconButton aria-label="Close patient summary" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ maxHeight: "75vh", bgcolor: "#f8fafc" }}>
        <FieldSummaryPanel data={data} />
      </DialogContent>
    </Dialog>
  );
}
